import NotifyDialogsService from '@Containers/Dialogs/NotifyDialogsService';

/**
 * @ngdoc method
 * @name showErrorAlert
 * @methodOf App.service:SearchImportFile
 * @description show error alert
 */
// eslint-disable-next-line import/prefer-default-export
export const showErrorAlert = (error) => {
  let message;
  // RXFE-5224, RXFE-5360
  switch (
    error &&
    error.errorNumber // case 1 (show error message from BE)
  ) {
    case 18:
      message = error.message;
      break;
    case 19: // case 3 (show no message if we send batch search request after query import)
      message = null;
      break;
    default:
      // case 2 (show default error message)
      message = 'Please use a saved Reaxys query- or Batch query file and try again.';
  }
  if (!message) {
    return;
  }
  const errorTitle = 'Sorry, this file is not supported';
  NotifyDialogsService.openModalWindow({
    title: errorTitle,
    text: message,
    type: 'alert',
    confirmText: 'OK, got it',
    advanced: {
      findMore: 'Find out more',
    },
    trackingOptions: {
      message: `${errorTitle} ${message}`,
      component: 'Search',
    },
  });
};
